import { render, staticRenderFns } from "./HomeBetCreator.vue?vue&type=template&id=0c22cacb&scoped=true&"
import script from "./HomeBetCreator.vue?vue&type=script&lang=js&"
export * from "./HomeBetCreator.vue?vue&type=script&lang=js&"
import style0 from "./HomeBetCreator.vue?vue&type=style&index=0&id=0c22cacb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22cacb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c22cacb')) {
      api.createRecord('0c22cacb', component.options)
    } else {
      api.reload('0c22cacb', component.options)
    }
    module.hot.accept("./HomeBetCreator.vue?vue&type=template&id=0c22cacb&scoped=true&", function () {
      api.rerender('0c22cacb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeBetCreator.vue"
export default component.exports